import { useState } from 'react';
import { useEffect } from 'react';

import cn from 'classnames';
import { useDocumentTitle } from 'hooks/document-title';
import { useQueryParams } from 'hooks/query-params';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, FormMessage, Input, InputGroup } from 'components/FormComponents';
import { Loading } from 'components/Loading/Loading';

import { useLazyGetSSOUrlQuery } from 'api/authentication-api';
import { verifySSO } from 'api/authentication-slice';

import styles from './SingleSignOn.module.scss';

export const SingleSignOn = () => {
  useDocumentTitle('Single Sign On');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [code] = useQueryParams(['code']);

  const [loading, setLoading] = useState(true);
  const [messageText, setMessageText] = useState();

  const [domain, setDomain] = useState('');

  const [getSSOUrl] = useLazyGetSSOUrlQuery();

  useEffect(() => {
    if (code) {
      dispatch(verifySSO(code)).then(
        () => navigate('/dashboard'),
        error => {
          setMessageText('Something went wrong. Please contact support');
          setLoading(false);
        },
      );
    } else {
      setLoading(false);
    }
  }, [code]);

  const getAuthUrl = async () => {
    setLoading(true);
    try {
      const result = await getSSOUrl(domain).unwrap();
      window.location.replace(result);
    } catch (e) {
      setMessageText('Domain not found.');
      setLoading(false);
    }
  };

  return (
    <div className={styles.root}>
      <Loading active={loading} />
      <div className={cn('card u-margin-top', 'card-with-shadow', styles.card)}>
        <div className={cn('card_content', styles.content)}>
          <img
            onClick={() => window.location.replace('https://www.checkmate.tech')}
            className={cn(styles.logo, 'u-margin-bottom--large')}
            src="/assets/images/checkmate/icon-label.svg"
            alt="Checkmate Logo"
          />
          <h2 className="u-margin-bottom--large">
            <span className="display-2 u-font-weight-400">Single&nbsp;</span>
            <span className="display-2 u-font-weight-600 brand-gradient-text">Sign On</span>
          </h2>
          <FormMessage
            message={messageText}
            className="u-margin-top--0"
            onClose={() => setMessageText(null)}
          />
          <InputGroup title="Company domain" className="u-margin-top">
            <Input
              placeholder="checkmate.tech"
              dataTestId="sso-domain-input"
              inputProps={{ value: domain, onChange: e => setDomain(e.target.value) }}
            />
          </InputGroup>
          <Button
            disabled={!domain}
            className="u-width-100"
            dataTestId="sso-submit-button"
            onClick={getAuthUrl}>
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SingleSignOn;
